import * as ko from "knockout"

export class PhantomViewModel {
    imageSrc: KnockoutObservable<string>;
    isLoading: KnockoutObservable<boolean>;
    imageConverted: (json: any, error: string) => void;
    getSelectedAreas: () => SelectedArea[];

    constructor(
        imageSrc: string,
        imageConverted: (json: any, error: string) => void,
        getSelectedAreas: () => SelectedArea[]
    ) {
        this.imageSrc = ko.observable(imageSrc);
        this.isLoading = ko.observable(false);
        this.imageConverted = imageConverted;
        this.getSelectedAreas = getSelectedAreas;
    }

    convertImageToHtml() {
        const self = this;
        this.isLoading(true);
        const selectedAreas = this.getSelectedAreas();
        console.info(selectedAreas);

        const crops: KnockoutObservableArray<PhantomCrop> = ko.observableArray([]);
        selectedAreas.forEach((selectedArea) => {
            crops.push(new PhantomCrop(selectedArea.x, selectedArea.y, selectedArea.width, selectedArea.height));
        });

        $.ajax({
            url: "/api/1.0/phantom/",
            method: "POST",
            data: { ImageSrc: this.imageSrc(), CropsJson: ko.toJSON(crops()) }
        }).done(function (data) {
            self.imageConverted(data, null);
        }).fail(function (jqXHR, errorTextStatus, error) {
            self.imageConverted(null, "We were unable to create the signature because of an unforeseen error.  Sorry!");
        }).always(() => self.isLoading(false));
    }
}

export class SelectedArea {
    id: string;
    x: number;
    y: number;
    z: number;
    width: number;
    height: number;
}

export class PhantomCrop {
    constructor(public x1: number, public y1: number, public width: number, public height: number) {

    }
}


// WEBPACK FOOTER //
// ./code/PhantomViewModel.ts